/**
 * @ngInject
 *
 * @param {$httpProvider}     $httpProvider
 * @param {$logProvider}      $logProvider
 * @param {$compileProvider}  $compileProvider
 */
export default ($httpProvider, $logProvider, $compileProvider) => {
  // Attach needed interceptors
  $httpProvider.interceptors.push('ErrorInterceptor');
  $logProvider.debugEnabled(false);
  if ($logProvider.debugEnabled && process.env.NODE_ENV === 'development') {
    $logProvider.debugEnabled(true);
  }

  $httpProvider.useApplyAsync(true);
  $compileProvider.debugInfoEnabled(false);
};
